import { useEffect, useState } from "react";
import { getCompanyMeeting, validateMeeting } from "../../services/auth";
import { useNavigate } from "react-router-dom";

const MeetingList = () => {

    const navigate = useNavigate();
    const [data, setData] = useState([]);

    const localTime = (utcDate) => {
        try {
            const date = new Date(utcDate);
            const formattedDate = date.toLocaleString("en-GB", {
                timeZone: "Asia/Kolkata",
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            });
            return formattedDate.replace(",", "")
        } catch (error) {
            return utcDate;
        }
    };

    const fetchData = async () => {
        try {
            const { status, data, count } = await getCompanyMeeting();
            if (status === true) setData(data);
        } catch (error) {
        }
    };

    const checkMeeting = async (meetingData) => {
        try {
            const { status, message } = await validateMeeting({ meetingId: meetingData._id })
            if (status === true) {
                let queryParams = new URLSearchParams({
                    meetingPassword: meetingData?.meetingPassword,
                    meetingNumber: meetingData?.meetingId,
                    signature: meetingData.hostSignature,
                    duration: meetingData?.duration
                }).toString()
                navigate(`/host_meeting?${queryParams}`)
            } else if (status === false && message != '') {
                alert(message)
            }
        } catch (error) {
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="ls-widget">
                    <div className="tabs-box">
                        <div className="widget-title">
                            <h4>Meeting List</h4>
                        </div>
                        <div className="widget-content">
                            <div className="table-outer">
                                <table className="default-table manage-job-table">
                                    <thead>
                                        <tr>
                                            <th className="text-center">#User Code</th>
                                            <th className="text-center">#Job Code</th>
                                            <th className="text-center">Job Title</th>
                                            <th className="text-center">Duration</th>
                                            <th className="text-center">Start Time</th>
                                            <th className="text-center">Status</th>
                                            <th className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            data &&
                                            data?.length > 0 &&
                                            data.map((item) => (
                                                <tr>
                                                    <td className="text-center">{item?.userCode}</td>
                                                    <td>{item?.jobPostCode}</td>
                                                    <td>{item?.jobPostId?.title}</td>
                                                    <td>{item?.duration}</td>
                                                    <td>{localTime(item?.startDate)}</td>
                                                    <td>{item?.status}</td>
                                                    <td>
                                                        <div className="option-box d-flex gap-2">
                                                            <button
                                                                data-text="Edit Applications"
                                                                onClick={() => checkMeeting(item)}
                                                                style={{
                                                                    // width: "30px",
                                                                    // height: "30px",
                                                                    borderRadius: "50%",
                                                                    background: "#97144d",
                                                                    color: "white",
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    fontSize: "20px",
                                                                    outline: "none",
                                                                    border: "none",
                                                                }}
                                                            >
                                                                Go to Meeting
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MeetingList;
